import React from 'react';
import EventTicketsBasicInfoComponent from './event-ticket-basic-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';



export default function EventTicketsComponent({ handleFormSubmit, back, selectedEventTickets, events, handleInnerFormChange,  }: any) {
  const tabItems = [

    {
        id: 1,
        title: 'Basic Information',
        component: <EventTicketsBasicInfoComponent
          selectedEventTickets={selectedEventTickets}
          handleInnerFormChange={handleInnerFormChange}
          events={events}
        />,
        isVisible: true,
      },

     
   
   
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  );
}

